module.exports = __webpack_public_path__ + "img/galeria-captores-4.7c13d805.png";